export const parseFileSize = (size: number) => {
  const isBiggerThanMb = size > 10000;

  const unit = isBiggerThanMb ? 'MB' : 'KB';
  const divisor = isBiggerThanMb ? 1000000 : 1000;
  const value = (size / divisor).toFixed(2);

  return `${value} ${unit}`;
};
